<template>
  <div class="word-exam dialog">
    <div class="content">
      <div class="close" @click="onClose"></div>
      <div class="title">{{ course.name }}-智能测试</div>
      <div class="main">
        <div class="word-exam-title">
          <div>即将开始智能测试</div>
          <div>请选择需要测试的范围：</div>
        </div>
        <div>
          <el-radio-group v-model="learnType" text-color="#fff" fill="#5256e6">
            <el-radio-button
              :key="item.label"
              :label="item.label"
              :disabled="!item.value"
              v-for="item in wordExamInfo.list">
              {{item.label === 'already_unit_learn' ? '已学' : '单元卷'}}（{{item.value}}个）
            </el-radio-button>
          </el-radio-group>
        </div>
        <template v-if="learnType">
          <div class="headline">选择测试方式：</div>
          <div>
            <el-radio-group v-model="examType" text-color="#fff" fill="#5256e6">
              <el-radio-button label="online">在线测试</el-radio-button>
              <template v-if="learnType === 'already_unit_learn'">
                <el-radio-button label="download">下载试卷</el-radio-button>
              </template>
              <template v-else>
                <el-radio-button label="download_learn_before">下载学前测试卷</el-radio-button>
                <el-radio-button label="download_learn_after">下载学后测试卷</el-radio-button>
              </template>
            </el-radio-group>
          </div>
        </template>
        <template v-if="examType">
          <div>
            <div class="headline">选择测试类型（可多选）：</div>
            <el-checkbox-group v-model="examContent" text-color="#fff" fill="#5256e6">
              <el-checkbox-button
                v-for="item in examContentList"
                :key="item.label"
                :label="item.value">{{item.label}}</el-checkbox-button>
            </el-checkbox-group>
          </div>
        </template>
        <div class="btn-wrapper" v-if="examContent.length">
          <div
            v-if="examType === 'online'"
            @click="start('bdc_exam')"
            class="btn btn-orange-square">开始测试</div>
          <template v-else>
            <div
              @click="exportExamExcel"
              class="btn btn-blue-square">本地下载</div>
            <div
              @click="downloadWordExam"
              class="btn btn-orange-square">直接打印
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  RadioGroup,
  RadioButton,
  CheckboxGroup,
  CheckboxButton,
} from 'element-ui';
import api from '@/api/graphql/englishCourse';
import exportExcel from '@/services/exportExcel';
import utils from '@/services/utils';

export default {
  props: {
    course: {
      type: Object,
      default: () => {},
    },
    unit: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    ElRadioGroup: RadioGroup,
    ElRadioButton: RadioButton,
    ElCheckboxGroup: CheckboxGroup,
    ElCheckboxButton: CheckboxButton,
  },
  watch: {
    learnType() {
      this.examType = '';
      this.examContent = [];
    },
    examType() {
      this.examContent = [];
      const type = this.examType === 'online' ? 'online' : 'download';
      this.getExamOnlineModelList(type);
    },
  },
  data() {
    return {
      learnType: '',
      examType: '',
      examContent: [],
      wordExamInfo: [],
      examContentList: [],
    };
  },
  created() {
    this.getExamModelList();
  },
  methods: {
    onClose() {
      this.$emit('close', {
        scene: 'wordUnit',
      });
    },
    getExamModelList() {
      api.getExamModelList({
        courseId: this.course.id,
        unitId: this.unit.id,
      }).then(({ englishExamModelList }) => {
        this.wordExamInfo = englishExamModelList;
      }).catch((err) => {
        utils.error(err.message);
      });
    },
    getExamOnlineModelList(type) {
      api.getExamOnlineModelList({ type })
        .then(({ englishOnlineExamModelList }) => {
          this.examContentList = englishOnlineExamModelList;
        });
    },
    start(type) {
      this.$emit('change', {
        scene: 'quizzesDialog',
        params: {
          type,
          mode: this.learnType,
          examType: this.examType,
          examMode: this.examContent.join(','),
        },
      });
    },
    exportExamExcel() {
      api.getCourseData({
        type: 'bdc_exam',
        courseId: this.course.id,
        unitId: this.unit.id,
        mode: this.learnType,
        examType: this.examType,
        examMode: this.examContent.join(','),
      }).then(({ englishCourseData }) => {
        exportExcel.exportExcel(englishCourseData);
      });
    },
    downloadWordExam() {
      const routeData = this.$router.resolve({
        name: 'print-exam',
        query: {
          type: 'BDC',
          quizType: 'bdc_exam',
          courseId: this.course.id,
          unitId: this.unit.id,
          mode: this.learnType,
          examType: this.examType,
          examMode: this.examContent.join(','),
        },
      });
      window.open(routeData.href, '_blank');
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/common/dialog.scss";
@import "@/styles/variables.scss";
.word-exam {
  width: 122.5vh;
  height: 70vh;
  // min-width: 1028px;
  // min-height: 714px;
  .content {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    background: url("https://vanthink.oss-cn-qingdao.aliyuncs.com/bc087eae61a61248b3780207189f5267.png")
      no-repeat;
    background-size: 100% 100%;
    .title {
      font-size: 2.4vh;
      color: #fff;
    }
    .main {
      position: relative;
      flex: 1;
      padding: 30px 0 0 30px;
      background: url("https://vanthink.oss-cn-qingdao.aliyuncs.com/a94ea7e99ce798e3f48e48e85e8c0734.png")
        no-repeat;
      background-size: 100% 100%;
      border-radius: 28px;
      .word-exam-title {
        color: $primary;
        font-weight: 700;
        div:first-child {
          margin-bottom: 15px;
          font-size: 2.5vh;
        }
        div:last-child {
          margin-bottom: 20px;
          font-size: 2vh;
        }
      }
      /deep/ .el-radio-group {
        .el-radio-button {
          margin: 0 20px;
          border: none;
          border-radius: 15px;
          .el-radio-button__inner {
            width: 100%;
            height: 100%;
            color: $primary;
            border: 1px solid $primary;
            border-radius: 15px;
          }
        }
        .el-radio-button:hover {
          .el-radio-button__inner {
            color: $primary;
          }
        }
      }
      /deep/ .el-checkbox-group {
        .el-checkbox-button {
          margin: 0 20px;
          border: none;
          border-radius: 15px;
          .el-checkbox-button__inner {
            width: 100%;
            height: 100%;
            color: $primary;
            border: 1px solid $primary;
            border-radius: 15px;
          }
        }
        .el-checkbox-button:hover {
          .el-checkbox-button__inner {
            color: $primary;
          }
        }
      }
      .headline {
        margin: 20px 0;
        color: $primary;
        font-size: 2.2vh;
        font-weight: 700;
      }
      .btn-wrapper {
        display: flex;
        position: absolute;
        left: 50%;
        bottom: 20px;
        transform: translateX(-50%);
        .btn {
          margin: 0 10px;
        }
      }
    }
  }
}
</style>
